{
  "colorFormat": "Color format",
  "hex": "Hex",
  "rgb": "RGB",
  "hsl": "HSL",
  "hsb": "HSB"
}
